import axiosInstance from "./axiosInstance";

export const getAllAppointments = async () => {
  try {
    const response = await axiosInstance.get("/appointment", {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch appointments");
  }
};

export const getAppointmentById = async (id) => {
  try {
    const response = await axiosInstance.get(`/fetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch appointment");
  }
};

export const createAppointment = async (formData) => {
  try {
    const response = await axiosInstance.post("/public/appointment", formData, {
      headers: {
        
        authType: "PreLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create appointment");
  }
};

export const deleteAppointment = async (id) => {
  try {
    const response = await axiosInstance.delete(`/delete/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete appointment");
  }
};